import { render, staticRenderFns } from "./getRejectDetail.vue?vue&type=template&id=88508bfa&lang=pug"
import script from "./getRejectDetail.vue?vue&type=script&lang=js"
export * from "./getRejectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports